<template>
    <v-card>
      <v-card-title>
        <span class="headline">Usage</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newUsg">
                <v-text-field :label="labels.vehUsg" v-model="vehUsgForm.vehUsg" :error-messages="errors.collect('vehUsg')" data-vv-name="vehUsg" :data-vv-as="labels.vehUsg" v-validate="'required|numeric|max:10'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.vehUsg}}</v-subheader>
                <div class="title">{{vehUsgForm.vehUsg}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.description" v-model="vehUsgForm.vehUsgDesc" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'required|entry|max:20'"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="permitStatus" v-model="vehUsgForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('permitStatus')" validate="'required'"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  props: {
    'vehUsgForm': Object,
    'newUsg': Boolean
  },
  data() {
    return {
      labels: {
        vehUsg: 'Usage Code*',
        description: 'Usage Description*',
        permitStatus: 'Permission Status*'
      }
    }
  },
  computed: {
    permitStatus() {
      return this.$store.state.vehicle.permitStatus
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vehUsgForm.vehUsg = undefined
      this.vehUsgForm.vehUsgDesc = undefined
      this.vehUsgForm.permitStatus = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newUsg) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vehicle.menu.createVehUsg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.vehUsgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vehicle.menu.updateVehUsg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.vehUsgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
